import { render } from "./FooterPaymentMethods.vue?vue&type=template&id=bc7a10da"
import script from "./FooterPaymentMethods.vue?vue&type=script&lang=js"
export * from "./FooterPaymentMethods.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__